import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faKey} from '@netx/core-icons';
import {canViewUserIntegrations} from '../enablers/canViewUserIntegrations';
import {UserIntegrationsLabel} from '../locales';

export const userIntegrationsActionRouteIcon = faKey;

/**
 * Route to user integrations
 * @param params
 * @returns Action
 */
export const userIntegrationsActionRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-integrations-route',
	cb: async () => performAction('user:integrations:route'),
	enableTest: () => canViewUserIntegrations(),
	icon: userIntegrationsActionRouteIcon,
	get label() {
		return UserIntegrationsLabel.ROUTE;
	},
	routeMatch: /^user\/integrations(\/?)/,
	...params,
});
